import { Modals } from '@/helpers/modals';
import type { INDBFlow } from './NDBFlow';

export const openNDBModals = (
  ndbFlow: INDBFlow | null,
  isAfterReleaseDate: boolean,
  confirmedAt: string | null | undefined,
  open: (modal: Modals) => void
) => {
  if (!ndbFlow?.isNDBEmailVerifiedShown && isAfterReleaseDate) {
    open(Modals.NDBEmailVerified);
  }
  if (!(ndbFlow?.isNDBEmailConfirmShown || confirmedAt)) {
    open(Modals.NDBEmailConfirm);
  }
};
